/**
 * Adapptio Core Library
 *
 * @package lib-core
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export * from "./GlobalsContainer";
export * from "./IBaseGlobals";
export * from "./IViewGlobals";
